export default __webpack_public_path__ + "static/media/rotate.fa52ace0.svg";